import React, { Component } from 'react'
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import selecionarEmissaoMdfe from '../../actions/mdfe/selecionarEmissaoMdfe';
import { mapSituacaoTransmissaoMdfe, situacaoTransmissaoMdfe, mapSituacaoEventoMdfe } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';

export class EmissaoMdfe extends Component {

    getSituacaoEvento(historicoEvento) {
        if (historicoEvento == null) return null;

        const tipoEventoChave = historicoEvento.tipoEvento && historicoEvento.tipoEvento.chave;
        const situacaoTransmissaoChave = historicoEvento.situacaotransmissao && historicoEvento.situacaotransmissao.chave;

        if (situacaoTransmissaoChave === situacaoTransmissaoMdfe.erro) {
            return mapSituacaoEventoMdfe.get(situacaoTransmissaoMdfe.erro);
        }
        if (situacaoTransmissaoChave === situacaoTransmissaoMdfe.emTransmissao) {
            return mapSituacaoEventoMdfe.get(situacaoTransmissaoMdfe.emTransmissao);
        }
        if (tipoEventoChave === 'CANCELAMENTO') {
            return mapSituacaoEventoMdfe.get('CANCELADO');
        }
        if (tipoEventoChave === 'ENCERRAMENTO') {
            return mapSituacaoEventoMdfe.get('ENCERRADO');
        }
        return null;
    }

    exibirBotaoTransmitirEditar() {
        const mdfe = this.props.mdfe;
        if (mdfe.ultimoHistoricoEmissaoMDFe == null) return true;
        if (mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.chave === situacaoTransmissaoMdfe.erro) return true;
        return false;
    }

    exibirBotaoCancelar() {
        const mdfe = this.props.mdfe;
        if (mdfe.ultimoHistoricoEmissaoMDFe == null) return false;
        if (mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.chave !== situacaoTransmissaoMdfe.sucesso) return false;
        if (mdfe.ultimoHistoricoEventoMDFe != null && mdfe.ultimoHistoricoEventoMDFe.situacaotransmissao.chave == situacaoTransmissaoMdfe.sucesso) return false;
        return true;
    }

    exibirBotaoEncerrar() {
        const mdfe = this.props.mdfe;
        if (mdfe.ultimoHistoricoEmissaoMDFe == null) return false;
        if (mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.chave !== situacaoTransmissaoMdfe.sucesso) return false;
        if (mdfe.ultimoHistoricoEventoMDFe != null && mdfe.ultimoHistoricoEventoMDFe.situacaotransmissao.chave == situacaoTransmissaoMdfe.sucesso) return false;
        return true;
    }

    exibirBotaoImprimir() {
        const mdfe = this.props.mdfe;
        return mdfe.ultimoHistoricoEmissaoMDFe != null &&
            mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.chave === situacaoTransmissaoMdfe.sucesso;
    }

    exibirIconeMotivoErro(historico, prefix) {
        if (historico != null && historico.situacaotransmissao.chave === situacaoTransmissaoMdfe.erro) {
            const motivo = historico.motivo ? historico.motivo.replace(/Rejeição: /, '') : ''
            const tooltipId = `${prefix}-${historico.id}-${this.props.mdfe.id}`
            return (
                <span style={{ marginLeft: 4, display: 'inline-flex', alignItems: 'center' }}>
                    <a data-tip data-for={tooltipId}>
                        <span className="material-icons" style={{ fontSize: 16, color: '#e53935', cursor: 'pointer' }}>info</span>
                    </a>
                    <ReactTooltip id={tooltipId} type="dark" effect="solid">
                        <span>{motivo}</span>
                    </ReactTooltip>
                </span>
            )
        }
        return null
    }

    render() {
        const mdfe = this.props.mdfe;
        const situacaoEvento = this.getSituacaoEvento(mdfe.ultimoHistoricoEventoMDFe);
        return (
            <div className="vx-row-item">
                <div className="vx-row-item-inner vx-row-item-inner--mdfe">
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Id</span>
                        {mdfe.id}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data de Emissão</span>
                        {mdfe.dataEmissao && <Moment format="DD/MM/YYYY">{mdfe.dataEmissao}</Moment>}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Placa</span>
                        {mdfe.veiculo ? mdfe.veiculo.placa : '-'}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">UF Inicial / Final</span>
                        {mdfe.cidadeOrigem && mdfe.cidadeOrigem.uf} / {mdfe.cidadeDestino && mdfe.cidadeDestino.uf}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Valor Total</span>
                        {mdfe.totalValorCargas != null
                            ? parseFloat(mdfe.totalValorCargas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                            : '-'}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Qtd CT-es</span>
                        {mdfe.quantidadeCtesVinculados != null ? mdfe.quantidadeCtesVinculados : '-'}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Status MDF-e</span>
                        {mdfe.ultimoHistoricoEmissaoMDFe == null
                            ? <span style={{ color: '#aaa', fontSize: 12 }}>Em preenchimento</span>
                            : <span style={{ color: mapSituacaoTransmissaoMdfe.get(mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.chave).textColor }}>
                                {mdfe.ultimoHistoricoEmissaoMDFe.situacaotransmissao.valor}
                                {this.exibirIconeMotivoErro(mdfe.ultimoHistoricoEmissaoMDFe, 'mdfe')}
                            </span>
                        }
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Status Evento</span>
                        {mdfe.ultimoHistoricoEventoMDFe == null
                            ? '-'
                            : <span style={{ color: situacaoEvento ? situacaoEvento.textColor : '#000000' }}>
                                {situacaoEvento ? situacaoEvento.label : '-'}
                                {this.exibirIconeMotivoErro(mdfe.ultimoHistoricoEventoMDFe, 'evento')}
                            </span>
                        }
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Ações</span>
                        <div className="dropdown">
                            <button className="vx-actions-trigger" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="material-icons">more_vert</span>
                            </button>
                            <div className="dropdown-menu vx-gp-dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {this.exibirBotaoTransmitirEditar() && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item" data-toggle="modal"
                                            data-target="#modalConfirmacaoTransmissaoMdfe"
                                            onClick={() => this.props.selecionarEmissaoMdfe(mdfe)}>
                                            <span className="material-icons">send</span>
                                            Transmitir MDF-e
                                        </a>
                                    </Autorizacao>
                                )}
                                {this.exibirBotaoCancelar() && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item" data-toggle="modal"
                                            data-target="#modalCancelamentoMdfe"
                                            onClick={() => this.props.selecionarEmissaoMdfe(mdfe)}>
                                            <span className="material-icons">delete</span>
                                            Cancelar MDF-e
                                        </a>
                                    </Autorizacao>
                                )}
                                {this.exibirBotaoEncerrar() && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item" data-toggle="modal"
                                            data-target="#modalEncerramentoMdfe"
                                            onClick={() => this.props.selecionarEmissaoMdfe(mdfe)}>
                                            <span className="material-icons">check_circle</span>
                                            Encerramento MDF-e
                                        </a>
                                    </Autorizacao>
                                )}
                                {this.exibirBotaoImprimir() && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item"
                                            onClick={() => this.props.history.push(`/imprimir-mdfe?mdfe=${mdfe.id}`)}>
                                            <span className="material-icons">print</span>
                                            Imprimir MDF-e
                                        </a>
                                    </Autorizacao>
                                )}
                                {this.exibirBotaoTransmitirEditar() ? (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoMdfe(mdfe);
                                            this.props.history.push('/painel-cadastro-mdfe');
                                        }}>
                                            <span className="material-icons">edit</span>
                                            Editar Dados do MDF-e
                                        </a>
                                    </Autorizacao>
                                ) : (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="vx-gp-dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoMdfe(mdfe);
                                            this.props.history.push('/painel-cadastro-mdfe');
                                        }}>
                                            <span className="material-icons">search</span>
                                            Visualizar Dados do MDF-e
                                        </a>
                                    </Autorizacao>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada
});

export default withRouter(connect(mapStateToProps, {
    selecionarEmissaoMdfe
})(reduxForm({
    form: 'formularioPainelMdfe'
})(EmissaoMdfe)));
